import { useHistory } from 'react-router-dom';
import { GetWaterPumpById, GetDevices } from 'apollo/configuration';
import { Text, Spin, FormCard, Select } from 'components';
import useComponents from 'hooks/useComponents';
import { I18n } from 'i18n';
import { Form } from 'antd';
import { Save } from '../components/water-pump-create/save';

const stateName = 'configuration.waterpumps';

export function WaterForm(props) {
  const { _id, onCloseDrawer } = props;
  const history = useHistory();
  const { data: dataWaterPumpById, isLoading, error } = GetWaterPumpById({ _id });
  const { data: dataDevices } = GetDevices();
  const memoDevices = dataDevices
    .filter((device) => device.type === 'sensor_actuators')
    .map((device) => ({
      value: device._id,
      name: device.name,
    }));
  const {
    onChange,
    configuration: { waterpumps },
  } = useComponents();

  if (_id && error) history.push('/error-server');

  return (
    <>
      {!isLoading ? (
        <>
          <Form layout="vertical">
            <FormCard
              title={I18n('basic_water_pumps_information')}
              description={I18n('configure_basic_water_pumps_information')}
            >
              <Text
                value={waterpumps?.name}
                default={dataWaterPumpById?.name}
                onChange={onChange}
                stateName={`${stateName}.name`}
                placeholder={`${I18n('name', true)}:*`}
                externalLabel
                required={true}
              />
            </FormCard>
            <FormCard
              title={I18n('location', true)}
              description={I18n('configuration_where_the_location_of_the_waterpump')}
            >
              <Text
                value={waterpumps.location}
                default={dataWaterPumpById?.location}
                onChange={onChange}
                stateName={`${stateName}.location`}
                placeholder={`${I18n('location', true)}`}
                externalLabel={false}
              />
            </FormCard>
            <FormCard
              title={I18n('device', true)}
              description={I18n('select_which_sensor_the_motor_pump_has', true)}
            >
              {memoDevices && memoDevices.length > 0 && (
                <Select
                  style={{ width: '100%' }}
                  default={dataWaterPumpById?.deviceId || memoDevices[0].value}
                  label={`${I18n('device', true)}:*`}
                  onChange={onChange}
                  stateName={`${stateName}.deviceId`}
                  data={memoDevices}
                  placeholder={`${I18n('device', true)}:*`}
                />
              )}
            </FormCard>
          </Form>
        </>
      ) : (
        <Spin spinning={isLoading} />
      )}
      <div className="rk-button-group">
        <Save _id={_id} onCloseDrawer={onCloseDrawer} />
      </div>
    </>
  );
}
